import { Link } from "@tanstack/react-router";
import { Check } from "lucide-react";

import { cn } from "@/components/ui/lib/utils";
import { getPlans } from "@/lib/subscriptions/subscriptions";
import * as m from "@/paraglide/messages";

export function PricingSection() {
	const plans = getPlans();

	return (
		<section className="px-4 py-20 md:px-12 md:py-28">
			<div className="mx-auto max-w-6xl rounded-[40px] bg-primary px-6 py-16 md:px-12 md:py-20">
				<div className="text-center">
					<h2 className="text-balance text-4xl font-semibold leading-tight text-primary-foreground md:text-5xl">
						{m.landing_pricing_heading1()}
						<br />
						<span className="font-extrabold italic">
							{m.landing_pricing_heading2()}
						</span>
					</h2>
				</div>

				<div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
					{plans.map((plan) => (
						<div
							key={plan.id}
							className={cn(
								"relative flex flex-col gap-5 rounded-3xl bg-card p-7 shadow-md",
								plan.highlighted && "ring-4 ring-secondary",
							)}
						>
							{plan.popular ? (
								<span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-secondary px-3 py-1 text-xs font-bold text-foreground">
									{m.landing_pricing_popular()}
								</span>
							) : null}
							<div className="flex items-baseline justify-between">
								<h3 className="text-xl font-bold text-foreground">{plan.name}</h3>
								<span className="text-2xl font-bold text-foreground">
									{plan.price}
									<span className="text-sm font-medium text-muted-foreground">
										{m.landing_pricing_perMonth()}
									</span>
								</span>
							</div>
							<p className="text-sm text-muted-foreground">{plan.description}</p>
							<div className="h-px bg-foreground/10" />
							<ul className="space-y-2.5">
								{plan.features.map((f) => (
									<li
										key={f}
										className="flex items-start gap-2 text-sm text-[#272727]"
									>
										<Check className="mt-0.5 size-4 shrink-0 text-primary" />
										{f}
									</li>
								))}
							</ul>
							<Link
								to="/sign-up"
								className={cn(
									"mt-auto inline-flex w-full items-center justify-center rounded-full px-5 py-3 text-sm font-semibold transition-shadow hover:shadow-md",
									plan.highlighted
										? "bg-secondary text-foreground"
										: "bg-foreground text-background",
								)}
							>
								{plan.cta}
							</Link>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
